import React from 'react';
import { Logo } from '../../../types';
import { ImageLoadingType } from '../Image/Image';
import { IconWrapper, IconImage } from './styles';

interface Props {
  image: Logo;
  socialLink: string;
  className?: string;
}

// { image } is the CMS asset for the image
// { socialLink } is the URL for the social media account
const SocialIcon = ({ image, socialLink, className, ...props }: Props) => (
  <IconWrapper
    title={image.altText}
    className={className}
    {...props}
    data-testid="social-icon-wrapper"
  >
    <a
      href={socialLink}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="social-icon-link"
    >
      <IconImage image={image} data-testid="social-icon-image" loading={ImageLoadingType.Lazy} />
    </a>
  </IconWrapper>
);

export default SocialIcon;
